export default {
   logout: "logout"

}

